"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfRevisionAuthors = void 0;
var RtfRevisionAuthors = (function () {
    function RtfRevisionAuthors() {
        this.authors = [];
    }
    RtfRevisionAuthors.prototype.getAuthor = function (authorIndex) {
        if (authorIndex < 0 || authorIndex >= this.authors.length)
            return RtfRevisionAuthors.unknownAuthor;
        return this.authors[authorIndex];
    };
    RtfRevisionAuthors.unknownAuthor = "Unknown";
    return RtfRevisionAuthors;
}());
exports.RtfRevisionAuthors = RtfRevisionAuthors;
